/*
 * AbTest
 * Framework level class not to be modified for AbTest implementations
 * The constructor has 4 params that will load from the registry when not set
 *   experimentKey -> string with the optimizely experiment key
 *   variantKeys -> dictionary of variant keys
 *   activeVariant -> active variant value
 *   isXHR -> boolean (if test is an XHR test)
 * */

import { has, implementAbTest } from './AbTestWrapper';

export class AbTest {
    constructor({
        isActive = false,
        name = null,
        experimentKey = null,
        variantKeys = null,
        activeVariant = null,
        isXHR = false,
        variantsList = [],
    } = {}) {
        this.isActive = isActive;
        this.name = name;
        this.experimentKey = experimentKey;
        this.variantKeys = variantKeys;
        this.activeVariant = activeVariant;
        this.isXHR = isXHR;
        this.objectType = 'AbTest';
        this.variantsList = variantsList;
    }

    implement() {
        implementAbTest(this); // Validates instantiated class
    }

    hasVariants() {
        return this.activeVariant !== 'control' && this.variantsList.includes(this.activeVariant);
    }

    run() {
        if (has(this, 'onRun')) this['onRun']();
    }
}
